<div class="row">

  <!-- ================= My Team ================= -->
  <div class="col-md-6">
    <h5 class="card-title">My Team</h5>

    <div class="card-box">
      <div class="list-row"
           *ngFor="let emp of attendanceDetails_data">

        <div class="left">
          <div class="name">
            {{ emp.emp_name }}
            <span class="code">
              [{{ !emp.orgempcode ? emp.tpcode : emp.orgempcode }}]
            </span>
          </div>
        </div>

        <div class="right">
          <span class="badge"
                [ngClass]="emp.today_status?.toLowerCase()">
            {{ emp.today_status }}
          </span>
        </div>
      </div>

      <div class="no-data"
           *ngIf="attendanceDetails_data.length === 0">
        No Team Data Found
      </div>
    </div>
  </div>

  <!-- ================= Upcoming Leaves ================= -->
  <div class="col-md-6">
    <h5 class="card-title">Upcoming Leaves</h5>

    <div class="card-box">
      <div class="list-row"
           *ngFor="let leave of upcomingLeaves">

        <div class="left">
          <div class="name">
            {{ leave.emp_name }}
          </div>
          <div class="sub-text">
            {{ leave.dateText }}
          </div>
        </div>

        <div class="right">
          <span class="leave-badge"
                [ngClass]="leave.leave_type?.toLowerCase().replace(' ', '-')">
            {{ leave.leave_type }}
          </span>
        </div>
      </div>

      <div class="no-data"
           *ngIf="upcomingLeaves.length === 0">
        No Upcoming Leaves
      </div>
    </div>
  </div>

</div>
